module.exports = {
  realm: 'AU',
  market: 'en-NZ',
  domain: 'weightwatchers.com.au',
  countryId: '6000',
  NZcountryId: '6001',
  vsPath: 'nz',
  spiceLocale: 'au',
  vsUrl: 'https://www{env}weightwatchers.com/nz',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/au/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.com.au/',
  currency: 'NZ$',
  decimalSeparator: '.',
  thousandSeparator: ',',
  currencyFormat: 'NZ$%number',
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.com.au/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.com.au/v2/login/',
  countryCode: 'AU',
  commUlr: 'https://commerce{env}weightwatchers.com/au/en/api/',
  timezone1: 'Pacific/Auckland',
  timezone2: '+12:00',
};
